export default function UnauthorizedPage() {
  const handleBackToHome = () => {
    // Clear all local storage
    localStorage.clear()
    // Redirect to login page
    window.location.href = '/auth/login'
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-8 text-center">
        <div className="mb-6">
          <svg
            className="mx-auto h-16 w-16 text-red-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          ไม่มีสิทธิ์เข้าถึง
        </h1>
        <p className="text-gray-600 mb-6">
          คุณไม่มีสิทธิ์ในการเข้าถึงหน้านี้ กรุณาติดต่อผู้ดูแลระบบหากคุณคิดว่าคุณควรมีสิทธิ์เข้าถึง
        </p>
        <div className="space-y-3">
          <button
            onClick={handleBackToHome}
            className="block w-full bg-brand-primary text-white py-2 px-4 rounded-md hover:bg-brand-primary/90 transition-colors"
          >
            กลับหน้าหลัก
          </button>
          <a
            href="/settings/packages"
            className="block w-full border border-gray-300 text-gray-700 py-2 px-4 rounded-md hover:bg-gray-50 transition-colors"
          >
            อัพเกรดแพ็กเกจ
          </a>
        </div>
      </div>
    </div>
  )
}
